import { Observable } from 'rxjs';
import { IPartnerConfig } from '@interticket/core';
import { IContact } from '../contact/contact.interface';
import { IOnlinePartner } from './online-partner.interface';

export abstract class IPartnerSource {

  abstract getConfig(): Observable<IPartnerConfig>;
  abstract getContacts(): Observable<IContact[]>;
  abstract getOnlinePartnerList(): Observable<IOnlinePartner[]>;

}
